import styled, { CSSProperties } from 'styled-components'
import { Container } from './Container'

export type TSVGElementProps = Pick<CSSProperties, 'strokeWidth' | 'transform'>
export const SVGContainer = styled(Container)<TSVGElementProps>`
  && svg {
    ${({ transform }) => transform && `transform: ${transform};`}

    path {
      ${({ strokeWidth }) => strokeWidth && `stroke-width: ${strokeWidth};`}
    }
  }
`
